// @flow

export const DashboardURLEnum = Object.freeze({
    LiveView: 'LIVE_VIEW',
    UserLiveView: 'USER_LIVE_VIEW',
    EditPlan: 'EDIT_PLAN',
    ViewPlan: 'VIEW_PLAN',
    Batch: 'BATCH',
    Upload: 'UPLOAD',
    Geocode: 'GEOCODE',
    Review: 'REVIEW',
    Configure: 'CONFIGURE'
});
